// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".home[data-v-e1bcd0b4]{margin-top:-116px;position:fixed;z-index:10;width:100%}", ""]);
// Exports
module.exports = exports;
